import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { SubscribeMessages } from "@/messages/subscribe/subscribe.messages";

import ProductImage from "./components/ProductImage";
import SubscriptionSummary from "./components/SubscriptionSummary";

type Props = {
  messages: SubscribeMessages;
};

function ProductInfoCard({ messages }: Props) {
  return (
    <Card sx={{ height: "100%" }}>
      <MDBox variant="gradient" borderRadius="xl">
        <MDBox p={2}>
          <Grid container spacing={6} p={2} size={{ md: 12 }}>
            <ProductImage />

            <MDBox
              my={2}
              width={"100%"}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              textAlign="center"
              gap={1}
            >
              <VerifiedUserIcon fontSize="medium" />

              <MDTypography variant="h5" fontWeight="regular">
                {messages.safeBuyLabel}
              </MDTypography>
            </MDBox>

            <SubscriptionSummary messages={messages} />
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default ProductInfoCard;
